export const API_TYPES = {
  AUTH: "auth",
  MATSEND: "matsend",
};

export const API_APP_NAMES = {
  MATSEND: "express_matsend",
};
